import { observer } from 'mobx-react'
import { useNavigate } from 'react-router'
import GlobalState from '../../../../stores/GlobalState'
import { Article } from '../../../../stores/SearchState'
import './index.scss'

const SearchItem = observer(
  ({ dt, number, button }: { dt: Article; number: number; button: string }) => {
    const navigate = useNavigate()
    return (
      <section className="search-item">
        <div className="search-item__col">
          <div className="search-item__text light">
            {number > 10 ? number : `0${number}`}
          </div>
        </div>
        <div className="search-item__col">
          <div className="search-item__text light">{dt.cat}</div>
          <div className="search-item__title">{dt.title}</div>
          {dt.text.length ? (
            <div
              className="search-item__text info"
              dangerouslySetInnerHTML={{ __html: dt.text }}
            ></div>
          ) : (
            <></>
          )}
          <div
            className="button grey-border"
            onClick={() => {
              const link = GlobalState.currentLocale.lang.includes('En')
                ? '/en'
                : GlobalState.currentLocale.lang.includes('ру')
                ? '/ru'
                : ''

              if (dt.maincat == 'news') {
                navigate(`${link}/${dt.maincat}/${dt.id}`)
              } else if (dt.slag == 'golovna') {
                navigate(`${link}/`)
              } else navigate(`${link}/${dt.slag}`)
            }}
          >
            {button}
          </div>
        </div>
      </section>
    )
  },
)

export default SearchItem
